<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="400">
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd=='tambah'">Tambah Kategori Produk</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Kategori Produk</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="12" sm="12" md="12" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.name=''" :error-messages="konfirmResponse.name"  v-model="paramAdd.name" label="Silahkan isi kategori produk"></v-text-field>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click.stop="dialog=false" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="timeout" right top :color="snackbarClass">
			{{ text }}
			<template v-slot:action="{ attrs }">
				<v-btn color="white" text v-bind="attrs" @click="snackbar = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</template>
		</v-snackbar>
	</v-row>
</template>

<script>
import {mapActions,  mapState} from 'vuex'
export default {
	data () {
		return {
			page: 1,
			limit: "10",
			params: [],
			snackbarClass : "green accent-4",
			snackbar: false,
			text : "",
			timeout: 2000,
			paramAdd: {
				name: '',
			},
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object
	},
	computed: {
		...mapState('productList', ['konfirmResponse', 'responSukses']),

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {
		...mapActions('productList', ['getProductCategory', 'addCategory', 'updateCategory']),

		batal() {
			this.dialog=false
			this.konfirmResponse.name=''
		},
		simpan() {
			if(this.paramAdd) {
				if(this.propAdd == 'tambah') {
					this.addCategory(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getProductCategory({limit:this.limit, page: 1, params:this.params})
							this.dialog= false
							this.snackbar = true
							this.text = this.responSukses.message
							this.reset()
						} else {
								this.dialog= true
						}
					})
				} else {
					this.updateCategory(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getProductCategory({limit:this.limit, page: 1, params:this.params})
							this.dialog= false
							this.snackbar = true
							this.text = this.responSukses.message
							this.reset()
						} else {
								this.dialog= true
						}
					})
				}
			}
		},
		reset () {
			this.paramAdd.name = ''
			this.konfirmResponse.name=''
		}
	},
	watch: {
		val () {
				this.paramAdd.id = this.val.product_category_id
				this.paramAdd.name = this.val.product_category_name
		}
	},
}
</script>
